import React from "react";
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
    // 다음 렌더링에서 폴백 UI가 보이도록 상태를 업데이트 합니다.
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        this.sendErrorToServer(error,info);
    }
    sendErrorToServer(error,info) {
        console.log(`error : ${error},  info : ${JSON.stringify(info)}`)
    // ...
    }
    render() {
        if (this.state.hasError) {// 폴백 UI를 커스텀하여 렌더링할 수 있습니다.
            return <h1>잘못된 페이지 접근입니다.</h1>;
        }
        return this.props.children; 
    }
}
